var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", { staticClass: "login-page" }, [
      _c("div", { staticClass: "form" }, [
        _c(
          "form",
          {
            staticClass: "login-form",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.handleSubmit($event)
              }
            }
          },
          [
            _c("p", { staticClass: "message" }, [_vm._v("System")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.loginSystem,
                    expression: "loginSystem"
                  }
                ],
                attrs: { id: "loginSystem", name: "loginSystem" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.loginSystem = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { disabled: "", value: "" } }, [
                  _vm._v("Please select a system")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "WLDPTM" } }, [
                  _vm._v("WLDPTM")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "GSPN" } }, [_vm._v("GSPN")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "SUPPORT" } }, [
                  _vm._v("SUPPORT")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "SCMS" } }, [_vm._v("SCMS")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "CS" } }, [_vm._v("CS")])
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "message" }, [_vm._v("Login Information")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.loginId,
                  expression: "loginId"
                }
              ],
              attrs: {
                type: "text",
                name: "loginIdManual",
                required: "",
                autofocus: ""
              },
              domProps: { value: _vm.loginId },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.loginId = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "select",
              {
                attrs: { id: "loginId", name: "loginId" },
                on: {
                  change: function($event) {
                    _vm.loginId = $event.target.value
                  }
                }
              },
              [
                _c("option", { attrs: { disabled: "", value: "" } }, [
                  _vm._v("Select One")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: " " } }, [_vm._v("[ ] ")]),
                _vm._v(" "),
                _c("option", { attrs: { value: " " } }, [_vm._v("[ ] ")]),
                _vm._v(" "),
                _c("option", { attrs: { value: " " } }, [_vm._v("[ ] ")]),
                _vm._v(" "),
                _c("option", { attrs: { value: " " } }, [_vm._v("[ ] ")])
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.loginPwd,
                  expression: "loginPwd"
                }
              ],
              attrs: {
                id: "loginPwd",
                name: "loginPwd",
                type: "password",
                placeholder: "password",
                required: ""
              },
              domProps: { value: _vm.loginPwd },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.loginPwd = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.loginType,
                  expression: "loginType"
                }
              ],
              attrs: { id: "loginType", name: "loginType", type: "hidden" },
              domProps: { value: _vm.loginType },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.loginType = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.loadMenuKind,
                  expression: "loadMenuKind"
                }
              ],
              attrs: {
                id: "loadMenuKind",
                name: "loadMenuKind",
                type: "hidden"
              },
              domProps: { value: _vm.loadMenuKind },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.loadMenuKind = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("button", { attrs: { type: "submit" } }, [_vm._v("LOGIN")])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd2d51fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd2d51fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/login/LoginFromOtherSystem.vue
// module id = yX+a
// module chunks = 0